import { render } from "./AlertBanner.vue?vue&type=template&id=bb4a5b98&scoped=true"
import script from "./AlertBanner.vue?vue&type=script&lang=js"
export * from "./AlertBanner.vue?vue&type=script&lang=js"

import "./AlertBanner.vue?vue&type=style&index=0&id=bb4a5b98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb4a5b98"]])

export default __exports__